import "./style.css";

function PaddedContentArea(props) {
    return (
        <div className="content-area-padded-wraper">
            <div className="content-area-padded">
                {props.children}
            </div>
        </div>
    );
}

export default PaddedContentArea;